var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessory11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 280,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -13)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M577.707 110.682C556.227 136.716 520.271 145.93 486.083 149.001 480.343 121.215 455.704 17.9999 406.228 17.9999 362.852 17.9999 347.22 37.7106 325 37.7106 302.78 37.7106 287.148 17.9999 243.773 17.9999 194.296 17.9999 169.658 121.215 163.917 149.001 129.73 145.93 93.7732 136.698 72.2931 110.682 33.4303 63.6002-17.9595 98.2882 8.06933 149.959 49.1884 231.566 148.647 289 325 289 501.336 289 600.794 231.566 641.931 149.959 667.96 98.2882 616.57 63.6002 577.707 110.682Z",
    fill: "#664500",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.75 54C354.975 54 342.794 71.4591 325.5 71.4591 308.206 71.4591 296.026 54 262.25 54 217.74 54 199 176.25 199 176.25 199 176.25 222.168 217 325.5 217 428.851 217 452 176.25 452 176.25 452 176.25 433.26 54 388.75 54Z",
    fill: "#825D0E",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 108C199 108 236.48 144 325.5 144 414.538 144 452 108 452 108L452 144C452 144 411.845 180 325.5 180 239.155 180 199 144 199 144L199 108Z",
    fill: "#664500",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory11);
export default __webpack_public_path__ + "static/media/accessory11.dfe75f060cfb44b73cd78ee0813bff00.svg";
export { ForwardRef as ReactComponent };